<template>
  <div class="rounded pa-3 bg-grey-lighten-5 my-3 course_item bordered" v-if="tarif.metadatas">
    <div class="mb-4">
      <b>{{ tarif.nom }}</b> <v-chip color="primary-dark" variant="elevated" elevation="0" density="compact">{{ tarif.nb_inscrits }} inscrits</v-chip>
    </div>
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field v-model="tarif.nom" label="Nom du tarif"></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field v-model="tarif.prix" type="number" label="Prix" append-inner-icon="mdi-currency-eur"></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field v-model="tarif.max_inscrits" type="number" label="Max inscrits (0 si pas de limite)" :disabled="is_disabled"></v-text-field>
      </v-col>
      <v-col cols="12" md="6" v-if="is_disabled">
        <v-alert border="start" border-color="red" density="compact">La modification de ce champ à des répercussions sur d'autres paramètres du module d'inscription. Veuillez contacter yann@sportips.fr</v-alert>
      </v-col>
    </v-row>
    <div v-if="majorations.length > 0">
      <v-row v-for="(majoration, index_majoration) in majorations" :key="index_majoration">
        <v-col cols="12" md="2">
          <div>Majoration n°{{ index_majoration + 1 }}</div>
        </v-col>
        <v-col cols="12" md="5">
          <v-text-field v-model="majoration.date" type="date" label="Date de changement"></v-text-field>
        </v-col>
        <v-col cols="12" md="5">
          <v-text-field v-model="majoration.tarif" type="number" label="Prix" append-inner-icon="mdi-currency-eur"></v-text-field>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { Tarif_Course } from "@/classes/Courses/Tarif_Course.class";
export default {
  props: ["item"],
  data() {
    return {
      tarif: new Tarif_Course(),
      majorations: [],
    };
  },
  watch: {
    majorations: {
      handler: function (val) {
        this.tarif.update_majorations(val);
      },
      deep: true,
    },
  },
  computed: {
    is_disabled() {
      return !this.tarif.is_max_editable();
    },
  },

  mounted() {
    this.tarif = this.item;
    this.majorations = this.tarif.get_majorations();
  },
};
</script>

<style lang="scss" scoped>
</style>